/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * Frequency of the schedule (ONE_TIME, DAILY, WEEKLY, MONTHLY)
 */
export enum ScheduledQuestionnaireConfigDtoFrequency {
  ONE_TIME = "ONE_TIME",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}
